// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
import Enum from 'enum'

/*
 * A table of "Web App" campaign types.
 * The order of which these types is declared is used for the
 * New Campaign Type menu
*/
const TYPES = {
  chat: {
    displayName: 'Enable Live Chat',
    iconSrc: require('./images/chat.svg'),
    serverType: 'CHAT',
    path: '/campaigns/new/chat',
    key: 'chat',
    description:
      'Use this to enable live chat for specific segments of users.'
  },

  email_capture: {
    displayName: 'Email Capture',
    iconSrc: require('./images/email-capture.svg'),
    svgIconSrc: require('!svg-inline?removeSVGTagAttrs=false&removeTags=true!images/svg/campaigns/email-capture.svg'),
    serverType: 'EMAIL_CAPTURE',
    path: '/wizard/email-capture',
    key: 'email_capture'
  },

  bot: {
    displayName: 'Bot',
    iconSrc: require('./images/bot.svg'),
    svgIconSrc: require('!svg-inline?removeSVGTagAttrs=false&removeTags=true!./images/bot.svg'),
    serverType: 'BOT'
  },

  announcement: {
    displayName: 'Announcement',
    iconSrc: require('./images/product-announcement.svg'),
    svgIconSrc: require('!svg-inline?removeSVGTagAttrs=false&removeTags=true!images/svg/campaigns/megaphone.svg'),
    grayIconSrc: require('./images/horn-gray.svg'),
    serverType: 'ANNOUNCEMENT_ONE_TIME',
    path: '/wizard/message',
    key: 'announcement',
    description: 'Use this to send an in-app message to many users at once.'
  },

  nps: {
    displayName: 'NPS Survey',
    iconSrc: require('./images/nps.svg'),
    svgIconSrc: require('!svg-inline?removeSVGTagAttrs=false&removeTags=true!images/svg/campaigns/star-circle.svg'),
    grayIconSrc: require('./images/nps-gray.svg'),
    serverType: 'NPS_ONE_TIME',
    path: '/wizard/nps',
    key: 'nps',
    description:
      'Send this to your users to measure how they feel about your product.'
  },

  nps_recurring: {
    displayName: 'NPS Survey',
    iconSrc: require('./images/nps.svg'),
    grayIconSrc: require('./images/nps-gray.svg'),
    serverType: 'NPS_RECURRING',
    key: 'nps',
    description:
      'Send this to your users to measure how they feel about your product.'
  },
  feedback: {
    displayName: 'Leave Feedback',
    iconSrc: require('./images/feedback.svg'),
    key: 'feedback',
    comingSoon: true,
    description:
      `Use this to get quick feedback from your customers through an \
in-app message.`
  },
  survey: {
    displayName: 'Survey',
    iconSrc: require('./images/survey.svg'),
    key: 'survey',
    comingSoon: true,
    description: 'Learn more from your users with robust questionnaires.'
  },
  banner: {
    displayName: 'Top Banner',
    iconSrc: require('./images/banner.svg'),
    key: 'banner',
    comingSoon: true,
    description:
      `Have something important to say? Use this to broadcast an announcement \
to your users.`
  },
  takeover: {
    displayName: 'Takeover',
    iconSrc: require('images/svg/takeover-icon.svg'),
    key: 'nps',
    comingSoon: true,
    description:
      `This full-screen campaign is useful for sharing important messages with \
your customers.`
  },
  rate: {
    displayName: 'Rate Support',
    iconSrc: require('./images/rate.svg'),
    svgIconSrc: require('!svg-inline?removeSVGTagAttrs=false&removeTags=true!./images/rate.svg'),
    key: 'rate',
    comingSoon: true,
    description:
      `How satisfied are your users after interacting with customer support? \
Use this to find out!`
  }
}

export { TYPES }

export const TypesByServerType = _.keyBy(TYPES, 'serverType')

// `messageType` attribute
export const MESSAGE_TYPE = new Enum([
  'CHAT',   // "web app" campaigns
  'EMAIL'  // email campaigns
])

// `periodLength` attribute
export const FREQUENCY = new Enum([
  'MONTHLY',    // sent every month
  'QUARTERLY'  // sent every quarter
])

// `delivery` attribute
export const DELIVERY_TIMEFRAME = new Enum([
  'NOW',      // delivered now. when making API calls, use ONLY FOR EMAILS, not chats
  'UNTIL',    // delivered until some end date
  'FOREVER'  // delivered forever (no end date)
])


export const EMAIL_TYPES = {
  announcement: {
    displayName: 'Announcement',
    iconSrc: require('./images/horn.svg'),
    grayIconSrc: require('./images/horn-gray.svg'),
    serverType: 'ANNOUNCEMENT_ONE_TIME',
    path: '/campaigns/new/email-announcement',
    key: 'announcement',
    description: 'Use this to send an email message to many users at once.'
  },
  nps: {
    displayName: 'NPS Survey',
    iconSrc: require('./images/nps.svg'),
    grayIconSrc: require('./images/nps-gray.svg'),
    serverType: 'NPS_ONE_TIME',
    path: '/campaigns/new/email-nps',
    key: 'nps',
    description: 'Send this to your users to measure how they feel about your product.'
  },

  nps_recurring: {
    displayName: 'NPS Survey',
    iconSrc: require('./images/nps.svg'),
    grayIconSrc: require('./images/nps-gray.svg'),
    serverType: 'NPS_RECURRING',
    key: 'nps',
    description: 'Send this to your users to measure how they feel about your product.'
  },
  survey: {
    displayName: 'Survey',
    iconSrc: require('./images/survey.svg'),
    key: 'survey',
    comingSoon: true,
    description: 'Learn more from your users with robust questionnaires.'
  },
  rate: {
    displayName: 'Rate Support',
    iconSrc: require('./images/rate.svg'),
    key: 'rate',
    comingSoon: true,
    description: 'How satisfied are your users  after interacting with customer support? Use this to find out!'
  }
}

export const STATUS = new Enum({
  QUEUED: {},
  SENT: {},
  RUNNING: {},
  NOT_RUNNING: {},
  ARCHIVED: {}
})



// WEBPACK FOOTER //
// ./src/scripts/components/campaign/constants.js